import { render, staticRenderFns } from "./FilterItemCompare.vue?vue&type=template&id=d049fd82&"
import script from "./FilterItemCompare.vue?vue&type=script&lang=js&"
export * from "./FilterItemCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports